export const IconStar = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="m20.88 8.36-5.62-.488-2.194-5.167c-.394-.94-1.741-.94-2.136 0L8.736 7.883l-5.607.476c-1.022.081-1.44 1.358-.662 2.032l4.26 3.692-1.277 5.48c-.232.998.848 1.787 1.73 1.253l4.818-2.902 4.818 2.914c.883.534 1.962-.256 1.73-1.254l-1.277-5.491 4.26-3.692c.779-.674.372-1.95-.65-2.032m-8.882 7.383-4.365 2.635 1.161-4.969-3.854-3.343 5.085-.441 1.973-4.68 1.986 4.691 5.085.441-3.855 3.344 1.161 4.969z" />
    </svg>
  );
};
